import React from "react";
import CenteredBox from "../boxes/CenteredBox";
import { CircularProgress, Typography } from "@mui/material";


const AppLoading = () => {
  return (
    <CenteredBox sx={{height: "100vh"}}>
      <CircularProgress id="circularProgress" color="primary" />
      <Typography
        variant="subtitle1"
        sx={{ margin: (theme) => theme.spacing(1) }}
      >
        Chargement...
      </Typography>
    </CenteredBox>
  );
};

export default AppLoading;
